export default {
  namespaced: true,
  app_modules: {
    title: "App Module | App Modules",
  },
};
